import { apiFetch } from '#imports'
import { useAuthStore } from '../stores/authStore'
import type { actionResponse } from '../types/cmsTypes'

export const Publish = async (): Promise<actionResponse> => {
  const authstore = useAuthStore()
  if (!authstore.token) {
    return { status_ok: false, message: 'nie masz tokena' }
  }

  const options = {
    method: 'POST'
  }
  const url = `/api/publish`

  return apiFetch(url, options)
}

export async function GetPipelineStatus(): Promise<actionResponse> {
  const authstore = useAuthStore()
  if (!authstore.token) {
    return { status_ok: false, message: 'nie masz tokena' }
  }

  const options = {
    method: 'GET'
  }
  const url = `/api/get-pipeline-status`

  return apiFetch(url, options)
}
